

import axios from 'axios';
import Cookies from 'js-cookie';

const instance = axios.create({
    baseURL: window.location.protocol + "//" + window.location.hostname + process.env.REACT_APP_API_APPENDIX,
    headers: {
        'Content-Type': 'application/json',
        // Add other common headers if needed
    }
});

// Add a request interceptor
instance.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        //const token = localStorage.getItem('token');
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

export default instance;